import { IonBadge, IonIcon } from '@ionic/react';
import { addOutline, createOutline, trashOutline } from 'ionicons/icons';
import React from 'react';
import './FolderStatusBadge.scss';

interface FolderStatusBadgeProps {
  changes: {
    added: number;
    modified: number;
    deleted: number;
    total: number;
  };
  className?: string;
}

export const FolderStatusBadge: React.FC<FolderStatusBadgeProps> = ({
  changes,
  className = '',
}) => {
  if (changes.total === 0) {
    return null;
  }

  const getBadgeColor = () => {
    if (changes.deleted > 0) return 'danger';
    if (changes.added > 0) return 'success';
    if (changes.modified > 0) return 'warning';
    return 'medium';
  };

  const getBadgeText = () => {
    const parts = [];
    if (changes.added > 0) parts.push(`${changes.added} added`);
    if (changes.modified > 0) parts.push(`${changes.modified} modified`);
    if (changes.deleted > 0) parts.push(`${changes.deleted} deleted`);
    return parts.join(', ');
  };

  const getBadgeIcon = () => {
    if (changes.deleted > 0) return trashOutline;
    if (changes.added > 0) return addOutline;
    if (changes.modified > 0) return createOutline;
    return undefined;
  };

  return (
    <IonBadge
      color={getBadgeColor()}
      className={`folder-status-badge ${className}`}
    >
      {getBadgeIcon() && (
        <IonIcon icon={getBadgeIcon()} className="badge-icon" />
      )}
      <span className="badge-text">{getBadgeText()}</span>
    </IonBadge>
  );
};
